var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items.length > 0)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items,"small":true,"fields":_vm.fields}})],1):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01425df3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/importables/Deliveries.vue
// module id = null
// module chunks = 